import axios, { AxiosResponse } from "axios";
import { IInvoice, InvoiceStatus } from "../models/invoice";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { ApiSearchResponse } from "../models/common";

export const addInvoice = async (invoice: IInvoice): Promise<AxiosResponse<IInvoice>> => {
    return await axios.post("/dispatcher/invoice", invoice);
};

export const changeInvoice = async (invoice: IInvoice): Promise<AxiosResponse<IInvoice>> => {
    return await axios.patch("/dispatcher/invoice", invoice);
};

export const deleteInvoice = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/invoice/${id}`);
};

export const getInvoice = async (id: string): Promise<AxiosResponse<IInvoice>> => {
    return await axios.get(`/dispatcher/invoice/${id}`);
};

export const searchInvoice = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IInvoice> => {
    return await axios.post("/dispatcher/invoice/search", searchParams);
};

export async function changeInvoiceStatus(invoiceId: number, status: InvoiceStatus) {
    return (await axios.patch<IInvoice>("/dispatcher/invoice/status", { status, invoiceId }))
        .data;
}

export async function copyCancelledInvoice(id: string) {
    return (await axios.post<IInvoice>(`/dispatcher/invoice/copyCancelled/${id}`)).data;
}

export async function getInvoiceCsvLink(id: string) {
    return (await axios.get<string>("/dispatcher/invoice/csvLink", { params: { invoiceId: id } }))
        .data;
}

export async function getInvoiceCsv(token: string) {
    return await axios.get<Blob>("/download/invoiceCsv", {
        baseURL: "/",
        params: { t: token },
        responseType: "blob",
    });
}
